import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.includes.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
export var subscribedTo = function subscribedTo(type, id, cb) {
  return finectAPI({
    version: 'v4',
    path: "users/me/subscriptions/".concat(type, "s/").concat(id),
    method: 'GET',
    onSuccess: function onSuccess(entity) {
      cb(entity);
      return entity.data.me === 'subscribed';
    },
    onError: function onError(err) {
      return cb(err);
    }
  });
};
export var subscribe = function subscribe(type, id, cb) {
  return finectAPI({
    version: 'v4',
    path: "users/me/subscriptions",
    method: 'POST',
    body: {
      type: type,
      id: id.toString()
    },
    onSuccess: function onSuccess(data) {
      return data;
    },
    onError: cb
  });
};
export var unsubscribe = function unsubscribe(type, id, cb) {
  return finectAPI({
    version: 'v4',
    path: "users/me/subscriptions?type=".concat(type, "&id=").concat(id),
    method: 'DELETE',
    onSuccess: function onSuccess() {
      return null;
    },
    onError: cb
  });
};
export var getEntity = function getEntity(type, id) {
  return finectAPI({
    version: 'v4',
    path: ['product'].includes(type) ? "products/".concat(id) : "contents/".concat(type, "s/").concat(id),
    method: 'GET',
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return data;
    }
  });
};